/**
 * "Nombre de parts" (NBR_PARTS) + recalcul des tranches "Revenus du ménage" (VE_REVENU_FOYER) - TRA-EQ-117.
 *
 * Partagé entre plusieurs pages (simulateur, pro, extranet...) - sélectionne les champs par le nom du champ
 * (indépendant du préfixe de formulaire, ex: front_vehicle_simulation_form[NBR_PARTS] ou ash_administration[NBR_PARTS]),
 * comme precarity-select.js. Ne fait rien si les champs NBR_PARTS/VE_REVENU_FOYER n'existent pas sur la page.
 *
 * Après chaque recalcul réussi, appelle window.onNbrPartsRecalculated() si défini, pour permettre à une page
 * d'y accrocher sa propre logique (ex: afficher/masquer la question "Gros rouleur" sur le simulateur).
 */
$('document').ready(function () {
    var $nbrParts = $('input[name*="[NBR_PARTS]"]');
    var $revenuFoyer = $('select[name*="[VE_REVENU_FOYER]"]');

    if ($nbrParts.length === 0 || $revenuFoyer.length === 0) {
        return;
    }

    function normalize(value) {
        var parsed = parseFloat(String(value).replace(',', '.'));
        return String(isNaN(parsed) || parsed < 1 ? 1 : parsed);
    }

    function loadRevenuFoyerTranche() {
        if (typeof Routing === 'undefined') {
            return;
        }
        var existingValue = $revenuFoyer.val();

        $.ajax({
            url: Routing.generate('api_get_gros_rouleur_revenu'),
            data: {nb_parts: $nbrParts.val()},
            dataType: 'json',
            success: function (choices) {
                $revenuFoyer.empty();
                $.each(choices, function (value, label) {
                    $revenuFoyer.append($("<option/>", {value: value, text: label}));
                });
                $revenuFoyer.val(existingValue);
                if ($revenuFoyer.find('option:selected').length === 0) {
                    $revenuFoyer.find('option:first').prop('selected', true);
                }
                if (typeof window.onNbrPartsRecalculated === 'function') {
                    window.onNbrPartsRecalculated();
                }
            }
        });
    }

    // Anti-rebond : un clic rapide sur +/- (ou une saisie) ne doit déclencher qu'UN seul appel AJAX,
    // 1s après la dernière modification - sinon les réponses qui arrivent dans le désordre s'empilent.
    var debounceTimeout = null;
    $nbrParts.on('change', function () {
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(loadRevenuFoyerTranche, 1000);
    });

    // Saisie directe : normalise au blur (virgule ou point accepté), minimum 1.
    $nbrParts.on('blur', function () {
        var normalized = normalize($nbrParts.val());
        if (normalized !== $nbrParts.val()) {
            $nbrParts.val(normalized).trigger('change');
        }
    });

    // +/- : pas de 0,25, minimum 1. Les boutons doivent avoir un id finissant par nbr-parts-increase/decrease
    // (ex: nbr-parts-increase, ash-nbr-parts-increase) - un seul champ NBR_PARTS par page.
    $(document).on('click', '[id$="nbr-parts-increase"], [id$="nbr-parts-decrease"]', function () {
        var current = parseFloat($nbrParts.val()) || 1;
        var delta = /increase$/.test(this.id) ? 0.25 : -0.25;
        var next = Math.max(1, Math.round((current + delta) * 100) / 100);
        $nbrParts.val(String(next)).trigger('change');
    });

    // Etat correct dès le chargement (valeur déjà rendue côté serveur), sans attendre l'AJAX de rafraîchissement.
    if (typeof window.onNbrPartsRecalculated === 'function') {
        window.onNbrPartsRecalculated();
    }
    loadRevenuFoyerTranche();
});
